import { render, staticRenderFns } from "./fppkNotificationEdit.vue?vue&type=template&id=6868ca42&scoped=true"
import script from "./fppkNotificationEdit.vue?vue&type=script&lang=js"
export * from "./fppkNotificationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6868ca42",
  null
  
)

export default component.exports